"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CounterInputContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseControlledState = _interopRequireDefault(require("@quid/react-use-controlled-state"));
var _CounterInput = require("./CounterInput");
var _excluded = ["defaultValue", "isValueChangeDelayed", "onBlur", "onChange", "value"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var CHANGE_VALUE_DELAY = 1000;
var SELECTION_DELAY = 10;
var CounterInputContainer = function CounterInputContainer(_ref) {
  var defaultValue = _ref.defaultValue,
    _ref$isValueChangeDel = _ref.isValueChangeDelayed,
    isValueChangeDelayed = _ref$isValueChangeDel === void 0 ? false : _ref$isValueChangeDel,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    value = _ref.value,
    originalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var maxValue = originalProps.maxValue;
  var changeValueTimeout = (0, _react.useRef)(null);
  var _useControlledState = (0, _reactUseControlledState["default"])(defaultValue !== undefined || value !== undefined ? defaultValue : _CounterInput.NUMBER_INPUT_MIN_VALUE, value, function () {
      return undefined;
    }),
    _useControlledState2 = (0, _slicedToArray2["default"])(_useControlledState, 2),
    stateValue = _useControlledState2[0],
    setStateValue = _useControlledState2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  var _useState3 = (0, _react.useState)({
      isDecreaseDisabled: stateValue === _CounterInput.NUMBER_INPUT_MIN_VALUE,
      isIncreaseDisabled: stateValue === maxValue
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    disabledButtons = _useState4[0],
    setDisabledButtons = _useState4[1];
  var verifyDisabledButtons = function verifyDisabledButtons(value) {
    setDisabledButtons({
      isDecreaseDisabled: value === _CounterInput.NUMBER_INPUT_MIN_VALUE,
      isIncreaseDisabled: value === maxValue
    });
  };
  (0, _react.useEffect)(function () {
    verifyDisabledButtons(stateValue);
  },
  //eslint-disable-next-line react-hooks/exhaustive-deps
  [stateValue]);
  var parseValue = function parseValue(value) {
    var parsedValue = _CounterInput.NUMBER_INPUT_MIN_VALUE;
    if (typeof value === 'string') {
      // remove non digits
      var digits = value.replace(/\D/g, '');
      if (digits === '') {
        return 0;
      }
      parsedValue = parseInt(digits, 10);
    } else {
      parsedValue = value;
    }
    if (parsedValue < _CounterInput.NUMBER_INPUT_MIN_VALUE) {
      return _CounterInput.NUMBER_INPUT_MIN_VALUE;
    }
    if (parsedValue > maxValue) {
      return maxValue;
    }
    return parsedValue;
  };
  var onValueChange = function onValueChange(value, attemptedValue) {
    onChange === null || onChange === void 0 ? void 0 : onChange(typeof value === 'string' ? undefined : value, attemptedValue);
  };
  var handleValueChange = function handleValueChange(value, attemptedValue) {
    if (isValueChangeDelayed) {
      if (changeValueTimeout.current) {
        clearTimeout(changeValueTimeout.current);
      }
      changeValueTimeout.current = setTimeout(function () {
        return onValueChange(value, attemptedValue);
      }, CHANGE_VALUE_DELAY);
    } else {
      onValueChange(value, attemptedValue);
    }
  };
  var handleBlur = function handleBlur() {
    if (stateValue === '' || stateValue === 0) {
      handleValueChange(_CounterInput.NUMBER_INPUT_MIN_VALUE, stateValue);
      verifyDisabledButtons(_CounterInput.NUMBER_INPUT_MIN_VALUE);
      setStateValue(_CounterInput.NUMBER_INPUT_MIN_VALUE);
    }

    // Timeout required for validation to work properly
    setTimeout(function () {
      return onBlur === null || onBlur === void 0 ? void 0 : onBlur(stateValue);
    });
  };
  var handleChange = function handleChange(value) {
    var parsedValue = parseValue(value);
    handleValueChange(parsedValue, value);
    verifyDisabledButtons(parsedValue);
    setStateValue(parsedValue);
  };
  var handleFocus = function handleFocus(e) {
    e.persist();
    setHasFocus(true);
    // NOTE: Timeout required to work properly on Safari
    setTimeout(function () {
      e.target.setSelectionRange(0, e.target.value ? e.target.value.length : 0);
    }, SELECTION_DELAY);
  };
  var onControlClick = function onControlClick(number) {
    return function () {
      var value = parseInt(stateValue, 10) + number;
      var parsedValue = parseValue(value);
      handleValueChange(parsedValue, value);
      verifyDisabledButtons(parsedValue);
      setStateValue(parsedValue);
      handleBlur();
    };
  };
  var handleDecreaseClick = onControlClick(-1);
  var handleIncreaseClick = onControlClick(1);
  var isDecreaseDisabled = disabledButtons.isDecreaseDisabled,
    isIncreaseDisabled = disabledButtons.isIncreaseDisabled;
  return /*#__PURE__*/_react["default"].createElement(_CounterInput.CounterInput, (0, _extends2["default"])({}, originalProps, {
    hasFocus: hasFocus,
    isDecreaseDisabled: isDecreaseDisabled,
    isIncreaseDisabled: isIncreaseDisabled,
    onBlur: handleBlur,
    onChange: handleChange,
    onDecreaseClick: handleDecreaseClick,
    onFocus: handleFocus,
    onIncreaseClick: handleIncreaseClick,
    value: stateValue
  }));
};
exports.CounterInputContainer = CounterInputContainer;